// @ts-nocheck
import * as React from "react";

// 저장 성공 토스트 — 화면 상단 중앙 고정. 저장 직후 다이얼로그가 닫히면
// 사용자 시선이 머무는 중앙 상단에 떠서 확실히 보인다. org-management에서
// 처음 도입한 패턴을 여러 화면이 공유하도록 컴포넌트로 추출.
//
// 사용법:
//   const { notifySaved, saveToast } = useSaveToast();
//   const save = async () => { await api.update(...); notifySaved(); };
//   return (<div className="app">... {saveToast}</div>);
//
// 메시지를 바꾸려면 notifySaved("초대했습니다")처럼 인자로 전달.

export function SaveToast({ message = "저장되었습니다" }) {
  return (
    <>
      <style>{`@keyframes saveToastSlideIn{from{opacity:0;transform:translate(-50%,-12px)}to{opacity:1;transform:translate(-50%,0)}}`}</style>
      <div role="status" aria-live="polite"
        style={{
          position:'fixed', top:86, left:'50%', transform:'translateX(-50%)', zIndex:80,
          display:'flex', alignItems:'center', gap:10,
          background:'var(--surface)', border:'1px solid var(--border-soft)',
          borderLeft:'4px solid var(--green-600)', borderRadius:12,
          padding:'12px 20px', boxShadow:'0 8px 28px rgba(0,0,0,0.18)',
          animation:'saveToastSlideIn 0.22s ease-out',
        }}>
        <span style={{
          width:22, height:22, borderRadius:999, background:'var(--green-600)', color:'#fff',
          display:'grid', placeItems:'center', fontSize:13, fontWeight:800, flexShrink:0,
        }}>✓</span>
        <span style={{fontSize:13.5, fontWeight:700, color:'var(--ink-1)'}}>{message}</span>
      </div>
    </>
  );
}

// 상태 + 2.2초 자동 해제 타이머를 캡슐화. notifySaved()를 저장 성공 직후 호출하고
// saveToast를 화면 최상위(div.app 안)에 렌더하면 된다.
export function useSaveToast() {
  const [message, setMessage] = React.useState(null);
  const timer = React.useRef(null);

  const notifySaved = React.useCallback((msg = "저장되었습니다") => {
    setMessage(msg);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setMessage(null), 2200);
  }, []);

  React.useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);

  const saveToast = message != null ? <SaveToast message={message} /> : null;
  return { notifySaved, saveToast };
}
